(function(){
var secondary={
  'chicago':'https://cdn.shopify.com/s/files/1/0691/3150/1801/files/Mock4_db46f0a3-4bc3-4baa-87e0-614106857d35.png?v=1723594016',
  'new-york':'https://cdn.shopify.com/s/files/1/0691/3150/1801/files/Mock4_cf50a16a-0232-4a9f-a2ad-720d2acc65e2.png?v=1729551933',
  'philadelphia':'https://cdn.shopify.com/s/files/1/0691/3150/1801/files/Mock4_1ab05666-5aa2-48ec-b7c0-09c5b354f502.png?v=1729552976',
  'boston':'https://cdn.shopify.com/s/files/1/0691/3150/1801/files/Mock2_5ac328ae-8cbc-456b-9a30-55e9f301acbf.png?v=1729553093',
  'denver':'https://cdn.shopify.com/s/files/1/0691/3150/1801/files/Mock2_c4c5aba6-1501-4bf9-a0be-91b1b14ce20f.png?v=1723592292',
  'poster-1':'https://cdn.shopify.com/s/files/1/0691/3150/1801/files/Mock4_6dd67e35-2dfc-41dd-a687-3dc29e0c956e.png?v=1723593375',
  'san-diego':'https://cdn.shopify.com/s/files/1/0691/3150/1801/files/Mock4_ae36ad42-3f01-47c9-830f-aaf75e258f0a.png?v=1729553745',
  'las-vegas':'https://cdn.shopify.com/s/files/1/0691/3150/1801/files/mock1_c461d86b-3039-40fa-8550-38794efcd2ee.png?v=1725853270',
  'san-francisco-1':'https://cdn.shopify.com/s/files/1/0691/3150/1801/files/mock1_b7ae7a21-5fdb-4cec-a855-e98151990cef.png?v=1725852888',
  'portland':'https://cdn.shopify.com/s/files/1/0691/3150/1801/files/Mock2_0bfacd5d-8131-46b9-a6fb-8cf6eb312bfb.png?v=1729658895',
  'austin':'https://cdn.shopify.com/s/files/1/0691/3150/1801/files/Mock3_fd186ade-d310-4cc7-995d-8b3f386b08ad.png?v=1729554290',
  'washington':'https://cdn.shopify.com/s/files/1/0691/3150/1801/files/Mock2_f323fbf4-5613-4e74-b04d-921c42d4d9d2.png?v=1730013858',
  'san-francisco-2':'https://cdn.shopify.com/s/files/1/0691/3150/1801/files/enhanced-matte-paper-poster-_in_-8x10-front-6718a413cc3ab.jpg?v=1729668124',
  'chicago-1':'https://cdn.shopify.com/s/files/1/0691/3150/1801/files/enhanced-matte-paper-poster-_in_-8x10-front-6718a3c22b30a.jpg?v=1729668043',
  'raleigh':'https://cdn.shopify.com/s/files/1/0691/3150/1801/files/enhanced-matte-paper-poster-_in_-8x10-front-66f0fc44052c5.jpg?v=1727069260',
  'providence':'https://cdn.shopify.com/s/files/1/0691/3150/1801/files/enhanced-matte-paper-poster-_in_-8x10-front-66e8bb0264c98.jpg?v=1726528268',
  'buffalo':'https://cdn.shopify.com/s/files/1/0691/3150/1801/files/enhanced-matte-paper-poster-_in_-8x10-front-66d246fbe539c.jpg?v=1725056778',
  'louisville':'https://cdn.shopify.com/s/files/1/0691/3150/1801/files/enhanced-matte-paper-poster-_in_-8x10-front-66c3f169457c8.jpg?v=1724117362',
  'berkeley':'https://cdn.shopify.com/s/files/1/0691/3150/1801/files/enhanced-matte-paper-poster-_in_-8x10-front-66bc3d8ce7a51.jpg?v=1723612566',
  'tampa':'https://cdn.shopify.com/s/files/1/0691/3150/1801/files/enhanced-matte-paper-poster-_in_-8x10-front-66b92026b1594.jpg?v=1723408432',
  'cincinnati':'https://cdn.shopify.com/s/files/1/0691/3150/1801/files/Mock4_c94ffb94-3079-4be9-adaa-bee6c84cd766.png?v=1729753757',
  'orlando':'https://cdn.shopify.com/s/files/1/0691/3150/1801/files/enhanced-matte-paper-poster-_in_-8x10-front-66ae8fd516f27.jpg?v=1722716124',
  'richmond':'https://cdn.shopify.com/s/files/1/0691/3150/1801/files/enhanced-matte-paper-poster-_in_-8x10-front-66ae8f82a3c59.jpg?v=1722716042',
  'cleveland':'https://cdn.shopify.com/s/files/1/0691/3150/1801/files/enhanced-matte-paper-poster-_in_-8x10-front-66ae8f3429fe2.jpg?v=1722715965'
};

function esc(v){return String(v==null?'':v).replace(/[&<>\"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','\"':'&quot;',"'":'&#39;'}[c];});}
function imageSrc(image){if(!image)return'';return typeof image==='string'?image:(image.src||image.url||'');}
function money(value){
  var n=parseFloat(value);
  if(!isFinite(n))return value||'';
  var currency=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';
  try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:currency}).format(n);}catch(e){return '$'+n.toFixed(2);}
}

function enhanceCards(root){
  (root||document).querySelectorAll('.gpt-full .gpt-product-card,.gpt-latest .gpt-product-card').forEach(function(card){
    var media=card.querySelector('.gpt-product-card__media');
    var primary=media&&media.querySelector('img:not(.gpt-product-secondary)');
    if(!media||!primary)return;
    primary.classList.add('gpt-product-primary');
    if(media.querySelector('.gpt-product-secondary'))return;
    var href=card.getAttribute('href')||'';
    var m=href.match(/\/products\/([^?#/]+)/);
    var handle=m&&m[1];
    var src=handle&&secondary[handle];
    if(src){
      var img=document.createElement('img');
      img.className='gpt-product-secondary';
      img.src=src;
      img.alt='';
      img.loading='lazy';
      media.appendChild(img);
    }
  });
}

function bindSmoothScroll(){
  var trigger=document.querySelector('.gpt-hero-room__button--dark[href="#GptCitySearch"]');
  var target=document.querySelector('.gpt-find');
  if(trigger&&target&&!trigger.dataset.gptSmoothBound){
    trigger.dataset.gptSmoothBound='1';
    trigger.addEventListener('click',function(e){
      e.preventDefault();
      var header=document.querySelector('.shopify-section-group-header-group')||document.querySelector('sticky-header')||document.querySelector('.header-wrapper');
      var offset=header?header.getBoundingClientRect().height:0;
      var y=target.getBoundingClientRect().top+window.pageYOffset-offset-10;
      window.scrollTo({top:Math.max(0,y),behavior:'smooth'});
    },true);
  }
}

function setupCityCovers(){
  var rail=document.querySelector('.gpt-city-shop .gpt-square-rail');
  if(!rail||rail.dataset.gptMockups)return;
  rail.dataset.gptMockups='1';
  var covers=[
    ['San Diego','https://cdn.shopify.com/s/files/1/0691/3150/1801/files/city-collection-cover-san-diego.png?v=1791157149'],
    ['Denver','https://cdn.shopify.com/s/files/1/0691/3150/1801/files/city-collection-cover-denver.png?v=1791157158'],
    ['Washington DC','https://cdn.shopify.com/s/files/1/0691/3150/1801/files/city-collection-cover-washington.png?v=1791157168'],
    ['San Francisco','https://cdn.shopify.com/s/files/1/0691/3150/1801/files/city-collection-cover-san-francisco.png?v=1791157178'],
    ['Los Angeles','https://cdn.shopify.com/s/files/1/0691/3150/1801/files/city-collection-cover-los-angeles.png?v=1791157187'],
    ['Las Vegas','https://cdn.shopify.com/s/files/1/0691/3150/1801/files/city-collection-cover-las-vegas.png?v=1791157196'],
    ['New York','https://cdn.shopify.com/s/files/1/0691/3150/1801/files/city-collection-cover-new-york.png?v=1791157209']
  ];
  rail.innerHTML=covers.map(function(c){
    return '<a class="gpt-city-collection-card" href="/collections/cities"><div><img src="'+c[1]+'" alt="'+esc(c[0])+' framed city poster mockup" loading="lazy" width="1024" height="1024"></div><h3>'+esc(c[0])+'</h3><p>Explore '+esc(c[0])+' →</p></a>';
  }).join('');
}

async function renderLatestCities(){
  var latest=document.querySelector('.gpt-home .gpt-latest');
  var track=latest&&latest.querySelector('.gpt-carousel-track');
  if(!track||latest.dataset.gptLatestDynamic)return;
  latest.dataset.gptLatestDynamic='loading';
  try{
    var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    var res=await fetch(root+'collections/cities/products.json?limit=250',{credentials:'same-origin',headers:{'Accept':'application/json'}});
    if(!res.ok)throw new Error('Latest Cities request failed: '+res.status);
    var payload=await res.json();
    var products=(payload&&payload.products)||[];
    if(!products.length)throw new Error('No Cities products returned');
    products.sort(function(a,b){
      var bd=Date.parse(b.created_at||b.published_at||0)||0;
      var ad=Date.parse(a.created_at||a.published_at||0)||0;
      return bd-ad;
    });
    var newest=products.slice(0,12);
    track.innerHTML=newest.map(function(p){
      var images=p.images||[];
      var primary=imageSrc(images[0]||p.image);
      var second=imageSrc(images[1]);
      var price=p.variants&&p.variants[0]?p.variants[0].price:'';
      return '<a class="gpt-product-card" href="/products/'+encodeURIComponent(p.handle)+'">'+
        '<div class="gpt-product-card__media">'+
          (primary?'<img class="gpt-product-primary" src="'+esc(primary)+'" alt="'+esc(p.title)+'" loading="lazy">':'')+
          (second?'<img class="gpt-product-secondary" src="'+esc(second)+'" alt="" loading="lazy">':'')+
        '</div>'+
        '<div class="gpt-product-card__meta"><h3>'+esc(p.title)+'</h3><p>'+esc(money(price))+'</p></div>'+
      '</a>';
    }).join('');
    latest.dataset.gptLatestDynamic='1';
    enhanceCards(latest);
  }catch(err){
    latest.dataset.gptLatestDynamic='failed';
    console.warn('[Latest Cities]',err);
  }
}

function initGptPolishV2(){
  bindSmoothScroll();
  enhanceCards(document);
  setupCityCovers();
  renderLatestCities();
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initGptPolishV2);}else{initGptPolishV2();}
setTimeout(initGptPolishV2,700);
})();
